import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import { cabinetPath } from '../lib/domains';

interface AdminProtectedRouteProps {
    children: React.ReactNode;
}

export const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
    const { isAuthenticated, isLoading } = useAdminAuth();
    const location = useLocation();

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-slate-900 dark:border-slate-300"></div>
            </div>
        );
    }

    if (!isAuthenticated) {
        // Перенаправляем на страницу входа, но сохраняем текущий путь
        return <Navigate to={cabinetPath('admin', '/login')} state={{ from: location }} replace />;
    }

    return <>{children}</>;
};
